import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  initPlayer,
  getTrackSize,
  downloadComplete,
  currTrack,
  classStarted,
  currPlaylist,
  currClassTime,
  totalClassTime,
  currSectionTime,
  totalSectionTime,
  setClass,
  setTracks,
  setTrackArrBuffer,
  setCurrTrackPos,
  setCurrTrackLength
} from 'store/actions/playerAction'
import { toggleOverlay } from 'store/actions/overlayAction'

import FileHelper from '../helpers/FileHelperWeb'
import MediaHelper from '../helpers/MediaHelper'
import {
  secondsToMilliseconds,
  hoursMinSecStringToSecs,
  minutesToMilliseconds
} from '../helpers/TimeHelper'
import {logSystem,logError} from '../helpers/LogHelper'
import { shuffleArray } from '../helpers/ArrayHelper'

import WaveformWrapper from '../components/WaveformWrapper'
import Nav from '../components/Nav'
import PlayerMain from './player/PlayerMain'
import Button from 'ui/Button'

class PlayerContainer extends React.Component{

  constructor(props){
    super(props)
    this.fs = null
    this.config = {
      localPath:'',
      libraryPlaylist:8515
    }
    this.state = {
      mode:'',
      availableTracks:[],
      unavailableTracks:[],
      currTrackList:[],
      classSchedules:[],
      classTotalTime:null,
      trackIndex:-1,
      skipIndex:0,
      scheduleIndex:0,
      currTimeMs:0,
      sectionTimeMs:0,
      status:'',
      downloadSize:0,
      isDownloading:false,
      needsDownload:false,
      init:false,
      isPlaying:false
    }
    this.player = {
      currPlayer:0,
      skipTimer:null
    }
    this.classTimers = {
      totalTimer:null,
      sectionTimer:null,
      currTimeMs:null,
      sectionTimeMs:null
    }
  }

  componentDidMount(){
    this.fsInit()
  }

  componentDidUpdate(prevProps){
    if(
      prevProps.tracks !== this.props.tracks &&
      prevProps.playlists !== this.props.playlists &&
      prevProps.schedules !== this.props.schedules && 
      prevProps.classes !== this.props.classes
    ){
      logSystem('SAVE TRACKS')
      this.saveTracksJson()
    }
    if(prevProps.downloadSize !== this.props.downloadSize){
      logSystem('DOWNLOAD SIZE')
      this.setDownloadSize()
    }
    if(prevProps.trackSrcs !== this.props.trackSrcs && this.state.isDownloading){
      logSystem('NEXT DOWNLOAD')
      this.getNextDownload()
    }
    if(prevProps.startClass !== this.props.startClass && this.props.startClass){
      logSystem('START CLASS')
      this.startClass()
    }
    if(prevProps.ptp !== this.props.ptp && this.props.ptp){
      logSystem('START PTP')
      this.startPtp()
    }
    if(prevProps.playlistOrder !== this.props.playlistOrder && this.props.playlistOrder){
      logSystem('SET PLAYLIST ORDER')
      this.setPlaylistOrder()
    }
    if(prevProps.selectTrack !== this.props.selectTrack && typeof this.props.selectTrack !== null){
      logSystem('SELECT TRACK')
      this.setTrack()
    }
    if(prevProps.skipIndex !== this.props.skipIndex && this.props.skipIndex){
      logSystem('SKIP TRACK')
      if(this.props.skipType === 'forward'){
        this.skipForward()
      } else {
        this.skipBack()
      }
    }
  }

  fsInit(){
    this.fs = new FileHelper()
    this.fs.init()
      .then(() => {
        logSystem('FS READY')
        this.httpInit()
      })
      .catch(err => logError(err))
  }

  httpInit(){
    this.props.dispatch(initPlayer())
  }

  saveTracksJson(){
    const filename = 'tracks.json'
    const path = this.config.localPath
    this.fs.checkFile(path,filename)
      .then((ret) => {
        if(ret){
          this.fs.deleteFile(path,filename)
            .then(() => {
              logSystem('NO FILE')
              return this.fs.writeJSON(path,filename,this.props.tracks,true)
            })
            .then(() =>{
              logSystem('SAVED TRACKS')
              this.savePlaylistsJson()
            })
            .catch((err) => logError(err))
        } else {
          this.fs.writeJSON(path,filename,this.props.tracks,true)
            .then(() =>{
              logSystem('SAVED TRACKS')
              this.savePlaylistsJson()
            })
            .catch((err) => logError(err))
        }
      })
      .catch((err) => logError(err))
  }

  savePlaylistsJson(){
    const filename = 'playlists.json'
    const path = this.config.localPath
    this.fs.checkFile(path,filename)
      .then((ret) => {
        if(ret){
          this.fs.deleteFile(path,filename)
            .then(() => {
              logSystem('NO FILE')
              return this.fs.writeJSON(path,filename,this.props.playlists,true)
            })
            .then(() =>{
              logSystem('SAVED PLAYLISTS')
              this.saveScheduleJson()
            })
            .catch((err) => logError(err))
        } else {
          this.fs.writeJSON(path,filename,this.props.playlists,true)
            .then(() =>{
              logSystem('SAVED PLAYLISTS')
              this.saveScheduleJson()
            })
            .catch((err) => logError(err))
        }
      })
      .catch((err) => logError(err))
  }
  
  saveScheduleJson(){
    const filename = 'schedules.json'
    const path = this.config.localPath
    this.fs.checkFile(path,filename)
      .then((ret) => {
        if(ret){
          this.fs.deleteFile(path,filename)
            .then(() => {
              logSystem('NO FILE')
              return this.fs.writeJSON(path,filename,this.props.schedules,true)
            })
            .then(() =>{
              logSystem('SAVED SCHEDULES')
              this.saveClassesJson()
            })
            .catch((err) => logError(err))
        } else {
          this.fs.writeJSON(path,filename,this.props.schedules,true)
            .then(() =>{
              logSystem('SAVED SCHEDULES')
              this.saveClassesJson()
            })
            .catch((err) => logError(err))
        }
      })
      .catch((err) => logError(err))
  }

  saveClassesJson(){
    const filename = 'classes.json'
    const path = this.config.localPath
    this.fs.checkFile(path,filename)
      .then((ret) => {
        if(ret){
          this.fs.deleteFile(path,filename)
            .then(() => {
              logSystem('NO FILE')
              return this.fs.writeJSON(path,filename,this.props.classes,true)
            })
            .then(() =>{
              logSystem('SAVED CLASSES')
              this.checkTracks()
            })
            .catch((err) => logError(err))
        } else {
          this.fs.writeJSON(path,filename,this.props.classes,true)
            .then(() =>{
              logSystem('SAVED CLASSES')
              this.checkTracks()
            })
            .catch((err) => logError(err))
        }
      })
      .catch((err) => logError(err))
  }

  checkTracks(){
    //local tracks array
    let tracksLocal = [];
    let tracksServer = [...this.props.tracks]
    let availableTracks = []
    this.fs.readDirectory(this.config.localPath)
      .then((data) => {
        //loop local files and push to local track array
        if(data.length > 0){
          for (var i = data.length - 1; i >= 0; i--) {
            if(data[i].name.indexOf('.json') == -1){
              tracksLocal.push(data[i].name);
            }
          }
        }
        logSystem('tracks local count = '+tracksLocal.length)
        //loop and remove from local arr if not in tracks
				for (var i = tracksServer.length - 1; i >= 0; i--) {
					for (var j = tracksLocal.length - 1; j >= 0; j--) {
						if(tracksLocal[j].replace('.mp3','') == this.props.tracks[i].id){
							//we have the file so no need to get
							availableTracks.push(this.props.tracks[i]);
							tracksLocal.splice(j,1);
						}
					}
        }
        //loop what's left and remove from local storage
				if(tracksLocal.length > 0){
					logSystem('delete local tracks length = '+tracksLocal.length);
					for (var k = tracksLocal.length - 1; k >= 0; k--) {
						this.fs.deleteFile('',tracksLocal[k])
							.then(function(res){
								logSystem(res);
							});
					}
        }
        //now loop again and set unavailable tracks
        
				for (var l = availableTracks.length - 1; l >= 0; l--) {
					for (var m = tracksServer.length - 1; m >= 0; m--) {
						if(availableTracks[l].id == tracksServer[m].id){
							tracksServer.splice(m,1);
						}
					}
        }
        this.setState({
          unavailableTracks:tracksServer,
          availableTracks:availableTracks,
          toDownload:tracksServer.length,
          init:true
        },() => {
          //set status
          if(this.state.unavailableTracks.length > 0){
            this.setStatus(`Remaining: ${this.state.unavailableTracks.length} of ${this.state.toDownload} tracks`)
            this.setState({
              needsDownload:true
            },() => {
              this.getDownloadSize()
            })
          } else {
            this.props.dispatch(setTracks([]))
          }
        })
      })
  }

  getDownloadSize(){
    for(let track of this.state.unavailableTracks){
      this.props.dispatch(getTrackSize(track.id))
    }
  }

  setDownloadSize(){
    this.setState({
      downloadSize:this.fs.formatBytes(this.props.downloadSize)
    })
  }

  prepareDownload(){
    this.setState({
      isDownloading:true
    },() => {
      this.downloadTrack()
    })
  }

  downloadTrack(){
    const track = this.state.unavailableTracks[0]
    fetch(track.file.filename.src)
      .then((res) =>  res.arrayBuffer())
      .then((buffer) => {
        this.fs.writeTrack(
          this.config.localPath,
          `${track.id}.mp3`,
          buffer,
          true
        )
        .then(() => {
          logSystem('track downloaded')
          this.setState({
            unavailableTracks:this.state.unavailableTracks.filter(trk => trk.id !== track.id)
          },() => this.getNextDownload())
        })
        .catch(err => logError(err))
      })
      .catch(err => logError(err))
  }

  getNextDownload(){
    if(this.state.unavailableTracks.length > 0){
      this.setStatus(`Remaining: ${this.state.unavailableTracks.length} of ${this.state.toDownload} tracks`)
      this.downloadTrack()
    } else {
      this.setStatus(null)
      this.props.dispatch(setTracks([]))
      this.setState({
        isDownloading:false,
        needsDownload:false
      })
    }
  }

  setStatus(status){
    this.setState({
      status:status
    })
  }

  swappingTracks(blnSwapping){
    this.setState({
      swappingTracks:blnSwapping
    })
  }

  logTrack(){

  }

  startPtp(){
    if(this.state.isPlaying){
      this.cancelClassTimers()
      this.resetPlayers()
        .then(() => {
          this.preparePlaylist()
        })
        .catch((err) => logError(err))
    } else {
      this.preparePlaylist()
    }
  }

  preparePlaylist(){
    this.setState({
      mode:'ptp',
      currTrackList:this.getPlaylistOrder([...this.props.ptp.tracks]),
      trackIndex:-1
    },() => {
      this.prepareNextTrack()
      this.props.dispatch(setTracks(this.state.currTrackList))
    })
  }

  startLibrary(){
    //if class running
    if(this.state.isPlaying && this.state.mode === 'class'){
      this.cancelClassTimers()
      this.resetPlayers()
        .then(() => this.prepareLibrary())
        .catch((err) => logError(err))
    } else if(this.state.isPlaying && this.state.mode === 'library'){
    //if playing the library, stop track
      this.resetPlayers()
        .then(() => this.setState({
          isPlaying:false,
          mode:'init'
        }))
        .catch((err) => logError(err))
    } else {
      //start library
      this.prepareLibrary()
    }
  }

  prepareLibrary(){
    const tracks = this.getPlaylistTracks(this.config.libraryPlaylist)
    this.setState({
      mode:'library',
      currTrackList:shuffleArray([...tracks]),
      trackIndex:-1
    },() => {
      this.props.dispatch(toggleOverlay(
        true,
        null,
        'player'
      ))
      this.prepareNextTrack()
    })
  }

  openClasses(){
    this.props.dispatch(toggleOverlay(
      true,
      null,
      'classes'
    ))
  }

  startClass(){
    this.props.dispatch(toggleOverlay())
    if(this.state.isPlaying){
      this.cancelClassTimers()
      this.resetPlayers()
        .then(() => {
          this.prepareClass()
        })
        .catch((err) => logError(err))
    } else {
      this.prepareClass()
    }
  }

  prepareClass(){
    
    this.setState({
      mode:'class',
      trackIndex:-1,
      scheduleIndex:0
    },() => {
      this.props.dispatch(classStarted())
      this.setClassSchedule()
        .then(() => this.startClassTimers())
        .then(() => this.prepareNextTrack())
        .catch((err) => logError(err))
    })
  }

  setClassSchedule(data){
    return new Promise((resolve,reject) => {
      const {classData} = this.props
      //get schedules
      let schedules = []
      for(let schedule of classData.sections){
        schedule.tracks = this.getPlaylistTracks(schedule.playlist_id)
        schedules.push(schedule)
      }
      //sort to start time
      schedules.sort((a,b) => {
        return a.start > b.start ? 1 : -1
      })
      //open overlay and send schedule
      this.props.dispatch(toggleOverlay(
        true,
        schedules,
        'playerClass'
      ))
      //set track list
      this.setState({
        currTrackList:this.getPlaylistOrder([...schedules[this.state.scheduleIndex].tracks]),
        classSchedules:schedules
      },() => {
        this.props.dispatch(setTracks(this.state.currTrackList))
        resolve()
      }) 
    })
  }

  startClassTimers(){
    return new Promise((resolve,reject) => {
      this.startClassTimerTotal()
        .then(() => this.startClassTimerSection())
        .then(() => resolve())
        .catch(err => logError(err))
    })
  }

  startClassTimerTotal(){
    return new Promise((resolve,reject) => {
      const {classData} = this.props
      const totalTime = secondsToMilliseconds(
        hoursMinSecStringToSecs(
          classData.sections[classData.sections.length - 1].end
        )
      )
      this.setState({
        currTimeMs:0
      })
      this.props.dispatch(totalClassTime(totalTime))
      //total timer
      this.classTimers.totalTimer = setTimeout(() => {
        this.resetPlayers()
        this.cancelClassTimers()
        this.props.dispatch(toggleOverlay())
        this.startLibrary()
      },totalTime)
      //curr time
      this.classTimers.currTimeMs = setInterval(() => {
        this.setState({
          currTimeMs:this.state.currTimeMs + 1000
        },() => {
          this.props.dispatch(currClassTime(this.state.currTimeMs))
        })
      }, 1000)
      resolve()
    })
  }

  startClassTimerSection(){
    return new Promise((resolve,reject) => {
      const {classSchedules} = this.state
      const start = classSchedules[this.state.scheduleIndex].start.split(':')
      const end = classSchedules[this.state.scheduleIndex].end.split(':')
      const sectionTime = minutesToMilliseconds(
        ((parseInt(end[0]) > 0 ? 60 : 0) + parseInt(end[1])) - (parseInt(start[1]) + (parseInt(start[0]) > 0 ? 60 : 0))
      )
      this.props.dispatch(totalSectionTime(sectionTime))
      this.classTimers.sectionTimer = setTimeout(() => {
        clearTimeout(this.classTimers.sectionTimer)
        clearTimeout(this.classTimers.sectionTimeMs)
        this.props.dispatch(currSectionTime(0))
        this.setState({
          sectionTimeMs:0
        })
        this.classTimers.sectionTimer = null
        this.prepareNextSection()
      },sectionTime)
      //set curr playlist
      this.props.dispatch(currPlaylist(
        classSchedules[this.state.scheduleIndex]
      ))
      //curr time
      this.classTimers.sectionTimeMs = setInterval(() => {
        this.setState({
          sectionTimeMs:this.state.sectionTimeMs + 1000
        },() => {
          this.props.dispatch(currSectionTime(this.state.sectionTimeMs))
        })
      }, 1000)
      logSystem('Started section timer')
      resolve()
    })
  }

  prepareNextSection(){
    const index = this.state.scheduleIndex + 1
    this.setState({
      scheduleIndex:index,
      currTrackList:shuffleArray(this.state.classSchedules[index].tracks)
    },() => {
      this.props.dispatch(setTracks(this.state.currTrackList))
      this.startClassTimerSection()
      this.preparePlayersForNextSection()
    })
  }

  cancelClassTimers(){
    clearTimeout(this.classTimers.totalTimer)
    this.classTimers.totalTimer = null
    clearTimeout(this.classTimers.sectionTimer)
    this.classTimers.sectionTimer = null
    clearInterval(this.classTimers.currTimeMs)
    this.classTimers.currTimeMs = null
    clearTimeout(this.classTimers.sectionTimeMs)
    this.classTimers.sectionTimeMs = null
    this.setState({
      mode:'init',
      isPlaying:false,
      currTimeMs:0,
      sectionTimeMs:0
    })
    this.props.dispatch(currClassTime(0))
    this.props.dispatch(totalClassTime(0))
    this.props.dispatch(currSectionTime(0))
    this.props.dispatch(totalSectionTime(0))
    this.props.dispatch(currPlaylist(null))
    this.props.dispatch(setTracks([]))
  }

  getPlaylistTracks(playlist_id){
    const {playlists} = this.props
    const playlist = playlists.find(elem => elem.id === playlist_id)
    return playlist.tracks
  }

  preparePlayersForNextSection(){
    const prevPlayer = this.player.currPlayer - 1
    const currPlayer = this.player.currPlayer
    //current player 
    if(this.player[currPlayer]){
      //if current player is fading in, cancel timers, start next track
      if(this.player[currPlayer].status.type === 2){
        //cancel the player timers, destroy next/prev player as this is now this player
        this.cancelPlayerTimers(currPlayer)
          .then(() => this.player[currPlayer].crossfadeOut())
          .then(() => this.destroyPlayer(prevPlayer))
        //prepare the next track
        this.prepareNextTrack()
      }
      //if current player is fading out, cancel the next player coming, next track prepped by loadTrack
      else if(this.player[currPlayer].status.type === 3){
        this.cancelPlayerTimers(prevPlayer)
          .then(() => this.player[prevPlayer].crossfadeOut())
          .then(() => this.destroyPlayer(prevPlayer))
      }
      //normal operation 
      else {
        //cancel the player timers 
        this.cancelPlayerTimers(currPlayer)
          .then(() => this.player[currPlayer].crossfadeOut())
          .then(() => {
            this.destroyPlayer(currPlayer)
          })
        //prepare the next track
        this.prepareNextTrack()
      }
    }
  }

  resetPlayers(){
    return new Promise((resolve,reject) => {
      const prevPlayer = this.player.currPlayer - 1
      const currPlayer = this.player.currPlayer
      //current player 
      if(this.player[currPlayer]){
        this.cancelPlayerTimers(currPlayer)
          .then(() => this.player[currPlayer].crossfadeOut())
          .then(() => {
            this.destroyPlayer(currPlayer)
            resolve()
          })
      }
      if(this.player[prevPlayer]){
        this.cancelPlayerTimers(prevPlayer)
          .then(() => this.player[prevPlayer].crossfadeOut())
          .then(() => {
            this.destroyPlayer(prevPlayer)
          })
      }
    })
  }

  cancelPlayerTimers(player){
    return new Promise((resolve,reject) => {
      this.player[player].clearTimers()
        .then(() => resolve())
        .catch((err) => reject(err))
    })
    //decide what you're going to do with the temp player
  }

  destroyPlayer(player){
    logSystem(`player ${player} finished`)
    if(this.player[player]){
      this.player[player].events.removeAllListeners()
    }
    this.player[player] = null
  }

  getNextPlayer(){
    return ++this.player.currPlayer
  }

  loadTrack(track){
    this.fs.readTrack(this.config.localPath,`${track.id}.mp3`)
      .then((trackSrc) => {
        //send array buffer for waveform
        //array buffer detached if track src contructed here?
        this.fs.readTrackArrBuffer(this.config.localPath,`${track.id}.mp3`)
          .then(arrBuffer => this.props.dispatch(setTrackArrBuffer(arrBuffer)))
          .catch(err => logError(err))
        //set curr player
        const currPlayer = this.getNextPlayer()
        this.player.currPlayer = currPlayer
        this.player[currPlayer] = new MediaHelper()
        this.setState({isPlaying:true})
        //load track
        this.player[currPlayer].init(trackSrc)
          .then(() => {
            this.props.dispatch(currTrack(track))
            logSystem(`${currPlayer} starting`)
            return this.player[currPlayer].startTimer()
          })
          .then(() => this.player[currPlayer].crossfadeIn())
          .then(() => {
            logSystem(`${currPlayer} started`)
            this.logTrack(track)
          })
          .catch(err => logError(err))
        //track length
        this.player[currPlayer].events.on('length',(length) => {
          this.props.dispatch(setCurrTrackLength(length))
        })
        //track position update
        this.player[currPlayer].events.on('position',(pos) => {
          this.props.dispatch(setCurrTrackPos(pos))
        })
        //track finishing
        this.player[currPlayer].events.on('finishing',() => {
          logSystem(`${currPlayer} finishing`)
          this.player[currPlayer].crossfadeOut()
            .then(() => {
              this.destroyPlayer(currPlayer)
            })
          this.player[currPlayer].events.removeListener('finishing')
          this.prepareNextTrack()
        })
      })
      .catch(err => logError(err))
  }

  prepareNextTrack(){
    
    this.setState({
      trackIndex:this.getNextTrackIndex()
    },() => {
      const {
        currTrackList,
        trackIndex
      } = this.state
      this.loadTrack(currTrackList[trackIndex])
    })
  }

  setTrack(){
    this.resetPlayers()
    this.setState({
      trackIndex:this.props.selectTrack
    },() => {
      const {
        currTrackList,
        trackIndex
      } = this.state
      this.loadTrack(currTrackList[trackIndex])
    })
  }

  skipForward(){
    if(this.player.skipTimer){
      clearTimeout(this.player.skipTimer)
      this.player.skipTimer = null
    }
    this.setState({
      skipIndex:++this.state.skipIndex
    },() => {
      this.skipTimerStart()
    })
  }
  
  skipBack(){
    if(this.player.skipTimer){
      clearTimeout(this.player.skipTimer)
      this.player.skipTimer = null
    }
    this.setState({
      skipIndex:--this.state.skipIndex
    },() => {
      this.skipTimerStart()
    })
  }

  skipTimerStart(){
    this.player.skipTimer = setTimeout(() => {
      this.resetPlayers()
      const trackIndex = this.getSkipTrackIndex()
      console.log(trackIndex)
      this.setState({
        trackIndex:trackIndex,
        skipIndex:0
      },() => {
        const {
          currTrackList,
          trackIndex
        } = this.state
        this.loadTrack(currTrackList[trackIndex])
      })
    },1000)
  }

  getSkipTrackIndex(){
    const {currTrackList} = this.state
    const skipTotal = this.state.trackIndex + this.state.skipIndex
    const arrLength = currTrackList.length - 1
    if(skipTotal > 0){
      return skipTotal <= arrLength ? skipTotal :  skipTotal - currTrackList.length
    }
    if(skipTotal < 0){
      return skipTotal >= 0 ? skipTotal : currTrackList.length + skipTotal
    }
    
  }

  getNextTrackIndex(){
    const {currTrackList} = this.state
    let index = this.state.trackIndex
    return index >= currTrackList.length - 1 ? 0 : index + 1
  }

  setPlaylistOrder(){
    const currTrackList = [...this.state.currTrackList]
    const tracks = this.props.playlistOrder === 'shuffle' ? shuffleArray(currTrackList) : this.orderTracks(currTrackList)
    this.setState({
      currTrackList:tracks
    },() => {
      this.props.dispatch(setTracks(this.state.currTrackList))
    })
  }

  getPlaylistOrder(tracks){
    return this.props.playlistOrder === 'shuffle' ? shuffleArray(tracks) : this.orderTracks(tracks)
  }

  orderTracks(tracks){
    return tracks.sort((a,b)=>{
      if(a.ordered && a.ordered[0] && b.ordered && b.ordered[0]){
        return a.ordered[0].pivot.index - b.ordered[0].pivot.index
      }
    })
  }

  getMainComp(){
    const {
      trackSrcs
    } = this.props
    const {
      unavailableTracks
    } = this.state
    //needs download prompt
    if(this.state.needsDownload && !this.state.isDownloading){
      return (
        <div className="downloading">
          <div>New update requiring {this.state.downloadSize} of space</div>
          {
            trackSrcs.length !== unavailableTracks.length || 
            <Button 
              name="Continue"
              action={() => this.prepareDownload()}/>
          }
        </div>
      )
    }
    //main interface
    if(!this.state.needsDownload && !this.state.isDownloading) {
      return (
        <PlayerMain
          mode={this.state.mode}
          startLibrary={() => this.startLibrary()}
          openClasses={() => this.openClasses()}/>
      )
    }
  }

  render(){
    //init
    if(!this.state.init){
      return (
        <div className="loading">Loading...</div>
      )
    }
    //downloading status
    if(this.state.isDownloading){
      return (
        <div className="downloading">
          <div>Downloading</div>
          <div>{this.state.status}</div>
        </div>
      )
    }
    return (
      <div className="main-container">
        <img className="sounds-logo" src="img/hotpod-sounds.svg"/>
        {this.getMainComp()}
        <img className="hp-logo" src="img/hotpod-logo.svg"/>
        <div className="version">v{process.env.REACT_APP_VERSION}</div>
      </div>
    )
  }
}
function mapStateToProps(store){
  return {
    playlists:store.player.playlists,
    tracks:store.player.tracks,
    schedules:store.player.schedules,
    classes:store.player.classes,
    downloadSize:store.player.downloadSize,
    trackSrcs:store.player.trackSrcs,
    startClass:store.player.startClass,
    classData:store.player.classData,
    ptp:store.player.ptp,
    playlistOrder:store.player.playlistOrder,
    selectTrack:store.player.selectTrack,
    skipIndex:store.player.skipIndex,
    skipType:store.player.skipType
  }
}
export default withRouter(connect(mapStateToProps)(PlayerContainer))


// WEBPACK FOOTER //
// ./src/modules/PlayerContainer.js